<div class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">

              <div class="row">
                <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
               <div class="col-md-7 d-flex justify-content-center">Configuration</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
    
            <div class="outside-container ">
            <div class="box-container ">
                <div class="container row">
                    <div class=" d-flex justify-content-start col-md-4" *ngFor="let item of settingJson" >
                        <mat-list class="col-md-12">
                          <ng-container  >
                          <span class="  d-flex justify-content-start">
                                <mat-icon *ngIf="item.icon" >{{item.icon}}</mat-icon>
                                <span [ngStyle] ="{'font-size': menu}" >{{ item.menu }}</span>
                              
                              </span>
                                <ng-container >
                                <mat-list >
                                <span *ngFor="let subMenu of item.subMenu" class=" d-flex justify-content-start mb-2" style=" height: 22px"> <span class="colorblue" (click)="OnClickLink(subMenu)">{{subMenu}}</span></span> 
                               
                              </mat-list>
                            </ng-container>
                          </ng-container>
                        </mat-list>
                     </div>
                     
                    </div>
                </div>